import Login from "@/views/Login.vue";

const login = {
  path: "/app/",
  name: "login",
  component: Login,
};

export default login;
